import './register.scss';
import React from 'react';
import { Translate, translate, Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Row, Col, Alert, Button } from 'reactstrap';
import { Redirect } from 'react-router';
import { IRootState } from 'app/shared/reducers';
import { handleGetInfo, reset } from './register.reducer';
import { ENP, IND, MSSP_PROVIDER, LINK_TERM_OF_USE, ORG, ERROR } from 'app/config/constants';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import RegisterBottom from './registerBottom';

export interface IRegisterSimProps extends StateProps, DispatchProps {
  userType: string;
}

export interface IRegisterSimState {
  redirectInfo: boolean;
  phone: string;
  visible: boolean;
  color: string;
  message: string;
  disableButtonReg: boolean;
  isDropDownOpen: boolean;
  strImg: string;
  name: string;
}
const imgVina = require('../../../images/vinaphone.png');
const imgViettel = require('../../../images/viettel.svg');
const imgMobi = require('../../../images/imgMobi.jpeg');
const imgBCY = require('../../../images/vgca.svg');

const nameVina = 'Sim PKI Vinaphone';
const nameViettel = 'Sim PKI Viettel';
const nameMobi = 'Sim PKI Mobifone';
const nameBCY = 'Sim PKI Ban Cơ yếu Chính phủ';

var arrName = [
  { id: '1', name: nameVina, image: imgVina },
  { id: '2', name: nameViettel, image: imgViettel },
  { id: '3', name: nameBCY, image: imgBCY },
  { id: '4', name: nameMobi, image: imgMobi }
];

export class RegisterSimPage extends React.Component<IRegisterSimProps, IRegisterSimState> {
  state: IRegisterSimState = {
    redirectInfo: false,
    phone: '',
    visible: false,
    color: 'info',
    message: '',
    disableButtonReg: false,
    isDropDownOpen: false,
    strImg: imgVina,
    name: MSSP_PROVIDER.VINA
  };

  componentWillMount() {
    window['is_mobile']();
    const userType = this.props.userType;
    if (userType == ORG) {
      arrName = [{ id: '3', name: nameBCY, image: imgBCY }];
      this.setState({
        name: MSSP_PROVIDER.BCY,
        strImg: imgBCY
      });
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.infoCert !== nextProps.infoCert) {
      const { infoCert } = nextProps;
      if (infoCert && infoCert.status === 'SUCCESS') {
        Storage.session.set('userType', this.props.userType);
        //Storage.session.set('phone', this.state.phone);
        Storage.session.set('type', 'Sim');
        Storage.session.set('certInfo', infoCert);
        this.setState({
          visible: false,
          redirectInfo: true,
          disableButtonReg: false
        });
      } else if (infoCert && infoCert.status) {
        this.setState({
          disableButtonReg: false,
          visible: true,
          color: 'danger',
          message: infoCert.message
        });
      } else {
        this.setState({
          disableButtonReg: false
        });
      }
      let timerId = setTimeout(() => {
        this.setState({
          visible: false
        });
      }, 3000);
    }
    if (nextProps.getInfoFailure) {
      this.setState({
        disableButtonReg: false,
        visible: true,
        color: 'danger',
        message:
          this.props.userType === ORG
            ? 'Không tìm thấy thông tin tổ chức tại cơ sở dữ liệu của Ban Cơ yếu, vui lòng liên hệ với đầu mối của Ban Cơ yếu để kiểm tra!'
            : 'Gửi yêu cầu ký không thành công vui lòng kiểm tra lại sim ký số!'
        // message:
        //   this.props.userType === IND
        //     ? 'Không tìm thấy thông tin cá nhân tại cơ sở dữ liệu của Ban Cơ yếu, vui lòng liên hệ với đầu mối của Ban Cơ yếu để kiểm tra!'
        //     : this.props.userType === ORG
        //     ? 'Không tìm thấy thông tin tổ chức tại cơ sở dữ liệu của Ban Cơ yếu, vui lòng liên hệ với đầu mối của Ban Cơ yếu để kiểm tra!'
        //     : 'Bạn đang dùng chứng thư số của Ban Cơ yếu vui lòng chọn chứng thư đúng để đăng ký doanh nghiệp!'
      });
    }
  }

  handleValidSubmit = (event, values) => {
    this.setState({
      //userType: values.userTypeSim ? values.userTypeSim : IND,
      //phone: values.mobile.trim(),
      visible: false
    });
    const userType = this.props.userType;
    this.props.handleGetInfo(values.mobile.trim(), this.state.name, userType);
    this.setState({
      disableButtonReg: true,
      visible: true,
      color: 'info',
      message: translate('global.messages.info.simPki.message')
    });
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  renderRedirect = () => {
    if (this.state.redirectInfo) {
      return (
        <Redirect
          push
          to={{
            pathname: '/info/register',
            state: {
              provider: this.state.name
            }
          }}
        />
      );
    }
  };

  toggle = () => {
    this.setState({
      isDropDownOpen: !this.state.isDropDownOpen
    });
  };

  clickItemDropDown = e => {
    switch (e.currentTarget.textContent) {
      case nameVina:
        this.setState({
          strImg: imgVina,
          name: MSSP_PROVIDER.VINA
        });
        break;

      case nameViettel:
        this.setState({
          strImg: imgViettel,
          name: MSSP_PROVIDER.VIETTEL
        });
        break;

      case nameBCY:
        this.setState({
          strImg: imgBCY,
          name: MSSP_PROVIDER.BCY
        });
        break;

      case nameMobi:
        this.setState({
          strImg: imgMobi,
          name: MSSP_PROVIDER.MOBI
        });
        break;

      default:
        break;
    }
  };

  render() {
    return (
      <div>
        {this.renderRedirect()}
        {/* <Row className="justify-content-center">
          <Col md="6">
            <h2 className="text-center font-weight-bold" id="register-title">
              <Translate contentKey="register.title">Registration</Translate>
            </h2>
            <p className="text-center txtContent">
              <Translate contentKey="register.txtContent" />
            </p>
          </Col>
        </Row> */}
        <Row className="justify-content-center">
          <Col>
            <AvForm id="register-form" onValidSubmit={this.handleValidSubmit}>
              {/* {window['is_mobile']() ? null : (
                <AvRadioGroup id="regToken" inline name="userTypeSim" value={IND} required>
                  <AvRadio customInput label="Công dân" value={IND} />
                  <AvRadio customInput label="Doanh nghiệp" value={ENP} />
                </AvRadioGroup>
              )} */}

              <div className="huong-dan-dk-sim">
                {/* <div className="title">Hướng dẫn đăng ký bằng Sim ký số</div> */}
                <Alert id="myAlert" color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
                  {this.state.message}
                </Alert>
                <div className="steps">
                  <div className="li">
                    <p>Nhập số điện thoại của Sim ký số.</p>
                    <Row style={{ flex: 1 }}>
                      <Col style={{ flex: 0.3 }}>
                        <Dropdown isOpen={this.state.isDropDownOpen} toggle={this.toggle}>
                          <DropdownToggle className="drop-down" caret>
                            <img className="icon-select-home-network" src={this.state.strImg} />
                          </DropdownToggle>
                          <DropdownMenu>
                            {arrName.map(item => (
                              <DropdownItem
                                className="drop-down-item"
                                style={{ width: 'max-content' }}
                                key={item.id}
                                onClick={this.clickItemDropDown}
                              >
                                <img className="icon-home-network-item" src={item.image} />
                                <label>{item.name}</label>
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </Col>

                      <Col style={{ flex: 0.7 }}>
                        <AvField
                          style={{ marginLeft: '-15px' }}
                          name="mobile"
                          placeholder={translate('global.form.mobile.placeholder')}
                          validate={{
                            required: { value: true, errorMessage: translate('global.messages.validate.mobile.required') },
                            number: { value: true, errorMessage: translate('global.messages.validate.mobile.invalid') }
                          }}
                        />
                      </Col>
                    </Row>
                  </div>
                  {/* <div className="li">2. Gắn thẻ Sim và bật điện thoại để sẵn sàng xác nhận Sim ký số</div>
                  <div className="li">
                    3. Bằng cách nhấp vào Đăng ký, bạn đồng ý với{' '}
                    <a className="link" href="">
                      Điều khoản, Chính sách chia sẻ thông tin
                    </a>{' '}
                    của chúng tôi
                  </div> */}
                  <label style={{ marginTop: '20px' }}>
                    <Translate contentKey="register.term1" />
                    <a href={LINK_TERM_OF_USE} target="_blank">
                      <Translate contentKey="register.term2" />
                    </a>
                    <Translate contentKey="register.term3" />
                  </label>
                </div>
              </div>

              <Button className="btn-register" type="submit" disabled={this.state.disableButtonReg} block>
                <Translate contentKey="register.form.button">Register</Translate>
              </Button>

              <div style={{ marginTop: '10px' }}>
                <RegisterBottom isInsurance={true} />
              </div>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  infoCert: storeState.register.infoCert,
  currentLocale: storeState.locale.currentLocale,
  getInfoFailure: storeState.register.getInfoFailure
});

const mapDispatchToProps = { handleGetInfo, reset };
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterSimPage);
